import { useTitle } from 'hooks/useTitle';

import Stack from '@mui/material/Stack';
import Title from 'shared/components/Title';
import DropdownButton from '../DropdownButton';

const TopBar = () => {
  const title = useTitle();

  return (
    <Stack alignItems="center" direction="row" spacing={3}>
      <Title>{title}</Title>
      <DropdownButton />
    </Stack>
  );
};

export default TopBar;
